module.exports = __webpack_public_path__ + "static/media/im-express-badge.9afaf1a7.svg";